import { MediaItem } from 'mytours-read-api-typescript'
import { Screen } from '../api/types'

export interface AudioPreview extends MediaItem {
	name?: string
	thumbnail_media_item?: MediaItem
}

interface AudioTrack {
	audio: AudioPreview
	coverImages?: any[]
	startTimes?: any[]
	fullScreenEnabled?: boolean
	slideshowEnabled?: boolean
	error?: unknown
}

interface AudioContainer {
	type: AudioSectionContainerType
	id: number
	title?: string // uses for analytics event
	collectionId: number // uses for analytics event
	screen: Screen // uses for analytics event
}

export interface PlaylistItem {
	playerStatus: PlayerStatus
	duration: number
	currentTime: number
	audioTrack: AudioTrack
	container: AudioContainer
}

export interface PreviewData {
	coverImages?: any[]
	startTimes?: any[]
	fullScreenEnabled?: boolean
	collectionId: number
	screen?: Screen
	slideshowEnabled?: boolean
}

export enum PlayerStatus {
	NotInit = 'not_initialized',
	Playing = 'playing',
	Pause = 'pause',
	Stop = 'stop',
	Loading = 'loading',
	Loaded = 'loaded',
	Error = 'loading_error',
	Ended = 'ended',
}

export type AudioSectionContainerType = 'section' | 'tour' | undefined
export interface AudioSectionContainer {
	type: AudioSectionContainerType
	id: number
	title?: string
}

export interface PlaylistIdParams {
	audioId: number
	containerId: number
	containerType: AudioSectionContainerType
	fileId: number
}
